import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { GroupsRoutingModule } from './groups-routing.module';
import { GroupsComponent } from './groups.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { ErrorModule } from 'src/app/components/error/error.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssignRoleComponent } from './assign-role/assign-role.component';
import { MatSelectModule } from '@angular/material/select';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { ViewPermissionsComponent } from './view-permissions/view-permissions.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { TableModule } from 'src/app/table/table.module';
import { GroupRolesComponent } from './group-roles/group-roles.component';

@NgModule({
  declarations: [
    GroupsComponent,
    AddGroupComponent,
    AssignRoleComponent,
    ViewPermissionsComponent,
    GroupRolesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    GroupsRoutingModule,
    ToolbarModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    ErrorModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    SearchFilterModule,
    MatDialogModule,
    PaginatorModule,
    TableModule
  ]
})
export class GroupsModule { }
